import { FC } from 'react'

import { ActivityType } from '@forto-dev/feed-v2-models'
import { Card, FeedItem, Table } from '@forto-dev/phoenix-ui-core'

import { HblTypeAll, isKnownHBLType, toHBLType } from '@/features/shipments'
import { useLocalisation } from '@/utils/localisation'

import { ActivityFeedItemProps } from './types'
import { isValidChangedField } from '../domain/feed'

const useShipmentUpdateTable = () => {
  const { translate } = useLocalisation()
  return [
    {
      id: 'changedFields',
      accessorKey: 'key',
      cell: ({ row: { original } }: { row: { original: { key: string; value: string } } }) => {
        return isValidChangedField(original.key)
          ? translate(`feed.list.shipmentUpdate.values.${original.key}`)
          : original.key
      },
    },
    {
      id: 'updatedValue',
      accessorKey: 'value',
    },
  ]
}

export const ActivityFeedItemShipmentUpdate: FC<ActivityFeedItemProps> = ({ item, status }) => {
  const { translate, translateDate } = useLocalisation()
  const columns = useShipmentUpdateTable()

  const { customField, type } = item.activity
  const changedFields =
    type === ActivityType.UpdateShipment ? customField?.changedFields : customField?.feedV1Activity?.changedFields

  const getHblValue = (value: HblTypeAll) => {
    const hblType = toHBLType(value)
    if (hblType === undefined) {
      return '-'
    }

    if (isKnownHBLType(hblType)) {
      return translate(`shipment.bill_of_lading_type.${hblType}`)
    }

    return hblType
  }

  const data = Object.entries(changedFields ?? {}).map(([key, value]) => ({
    key,
    value: key === 'hblType' ? getHblValue(value as HblTypeAll) : value,
  }))

  return (
    <FeedItem
      type="update"
      name={item.activity.actor.fullName || 'Service'}
      action={translate('feed.list.shipmentUpdate.action')}
      date={translateDate('feed_date', item.activity.createdAt)}
      suffix={item.activity.actor.type === 'Service' ? translate('feed.suffix.automated') : undefined}
      status={status}
    >
      <a id={`feed-activity-${item.id}`} />
      <Card>
        <Table data={data} columns={columns} footless headless />
      </Card>
    </FeedItem>
  )
}
